(function () {
  var KEY = 'ls-size-system';
  function saved() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function apply(sys) {
    document.querySelectorAll('.ls-sizes').forEach(function (fs) {
      if (sys) fs.setAttribute('data-ls-sz', sys);
      var cur = fs.getAttribute('data-ls-sz');
      fs.querySelectorAll('[data-ls-sz-set]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.lsSzSet === cur ? 'true' : 'false'); });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ls-sz-set]');
    if (!b) return;
    e.preventDefault();
    try { sessionStorage.setItem(KEY, b.dataset.lsSzSet); } catch (err) {}
    apply(b.dataset.lsSzSet);
  });

  var sizeChosen = false;
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.ls-sizes')) sizeChosen = true; });

  function setupSticky() {
    var bar = document.querySelector('[data-ls-sticky]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var sid = bar.dataset.section;
    var form = document.getElementById('product-form-' + sid);
    var btn = bar.querySelector('[data-ls-sticky-btn]');
    function mainBtn() { return form && form.querySelector('[type="submit"]'); }
    function label() {
      var mb = mainBtn();
      var tb = tierBox(); var tier = tb ? TIER[tb.dataset.section] || '1' : '1';
      if (tier === '2') { btn.textContent = PICK.variant ? 'Add both pairs' : 'Choose second pair'; return; }
      if (!sizeChosen && document.querySelector('.ls-sizes')) { btn.textContent = 'Choose your size'; return; }
      btn.textContent = mb && mb.disabled ? 'Sold out' : 'Add to cart';
    }
    btn.addEventListener('click', function () {
      var tb = tierBox(); var tier = tb ? TIER[tb.dataset.section] || '1' : '1';
      if (tier === '2' && !PICK.variant) { var picker = document.querySelector('[data-ls2-pick]'); if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); pickMsg('Choose the second shoe and its options first.'); return; }
      var sizes = document.querySelector('.ls-sizes');
      if (tier !== '2' && !sizeChosen && sizes) { sizes.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var mb = mainBtn(); if (mb && !mb.disabled) mb.click();
    });
    document.addEventListener('change', function () { setTimeout(label, 50); });
    var target = mainBtn();
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
      label();
    }).observe(target);
    var price = bar.querySelector('[data-ls-sticky-price]');
    new MutationObserver(function () {
      var p = document.querySelector('#price-' + sid + ' .ls2-price__now, #price-' + sid + ' .ls2-price__full, #price-' + sid + ' .price-item--last, #price-' + sid + ' .price-item--regular');
      if (p && price) price.textContent = p.textContent.trim();
    }).observe(document.getElementById('price-' + sid) || document.body, { childList: true, subtree: true });
  }


  /* Offer tiers: One pair / Two pairs radio cards drive the form quantity and the add to cart label. */
  var TIER = {};
  var PICK = { variant: null, price: 0, handle: null };
  var secondPairBusy = false;
  var productCache = {};
  function fmt(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(Math.round(cents) / 100); }
    catch (e) { return (Math.round(cents) / 100).toFixed(2); }
  }
  function pickMsg(t) { var m = document.querySelector('[data-ls2-pick-msg]'); if (m) m.textContent = t || ''; }
  function chooseCard(card) {
    var picker = card.closest('[data-ls2-pick]');
    var handle = card.dataset.handle;
    if (!picker || !handle) return;
    picker.querySelectorAll('[data-ls2-pick-card]').forEach(function (c) {
      c.setAttribute('aria-pressed', String(c === card));
    });
    PICK.variant = null;
    PICK.price = 0;
    PICK.handle = handle;
    var wrap = picker.querySelector('[data-ls2-pick-sizes]');
    var list = picker.querySelector('[data-ls2-pick-sb]');
    picker.querySelector('[data-ls2-pick-name]').textContent = card.dataset.name || '';
    if (!wrap || !list) return;
    wrap.hidden = false;
    list.textContent = 'Loading options...';
    pickMsg('Choose each option for your second pair.');
    applyTier();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'products/' + encodeURIComponent(handle) + '.js';
    var promise = productCache[handle] || (productCache[handle] = fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('Could not load product'); return r.json(); })
      .catch(function (e) { delete productCache[handle]; throw e; }));
    promise.then(function (p) {
      if (PICK.handle !== handle) return;
      list.innerHTML = '';
      var optionNames = (p.options || []).map(function (o) { return (o.name || o).toString(); });
      var selected = optionNames.map(function () { return ''; });
      var groups = [];
      var variants = (p.variants || []);
      function resolve() {
        var matching = variants.filter(function (v) {
          return v.options.every(function (o, i) { return !selected[i] || selected[i] === o; });
        });
        groups.forEach(function (g, i) {
          g.querySelectorAll('button[data-value]').forEach(function (btn) {
            var test = selected.slice();
            test[i] = btn.dataset.value;
            btn.disabled = !variants.some(function (v) {
              return v.available && v.options.every(function (o, n) { return !test[n] || test[n] === o; });
            });
            btn.setAttribute('aria-pressed', String(selected[i] === btn.dataset.value));
          });
        });
        var complete = selected.every(Boolean);
        var match = complete ? matching.find(function (v) { return v.available; }) : null;
        PICK.variant = match ? match.id : null;
        PICK.price = match ? Number(match.price) : 0;
        pickMsg(match ? (card.dataset.name + ' — ' + selected.join(' / ') + ' selected.') :
          (complete ? 'This combination is unavailable. Choose another option.' : 'Please choose all options for your second pair.'));
        applyTier();
      }
      if (!optionNames.length) {
        var v = variants.find(function (v) { return v.available; });
        if (v) {
          var selectDefault = document.createElement('button');
          selectDefault.type = 'button'; selectDefault.className = 'ls2-pick__size';
          selectDefault.textContent = 'Select this pair';
          selectDefault.addEventListener('click', function () { PICK.variant = v.id; PICK.price = Number(v.price); pickMsg('Second pair selected.'); applyTier(); });
          list.appendChild(selectDefault);
        } else list.textContent = 'This product is unavailable.';
        return;
      }
      optionNames.forEach(function (name, i) {
        var group = document.createElement('div');
        group.className = 'ls2-pick__option-group';
        var heading = document.createElement('p');
        heading.className = 'ls2-pick__sl';
        heading.textContent = name + ' — Second pair';
        var buttons = document.createElement('div');
        buttons.className = 'ls2-pick__sb ls2-pick__sb--option';
        var values = [];
        variants.forEach(function (v) {
          if (v.options[i] && values.indexOf(v.options[i]) < 0) values.push(v.options[i]);
        });
        values.forEach(function (value) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ls2-pick__size';
          btn.dataset.value = value;
          btn.textContent = /size/i.test(name) ? value.replace(/^US\s*/i, '').split('|')[0].trim() : value;
          btn.setAttribute('aria-pressed', 'false');
          btn.addEventListener('click', function () { selected[i] = value; resolve(); });
          buttons.appendChild(btn);
        });
        group.appendChild(heading); group.appendChild(buttons);
        list.appendChild(group); groups.push(group);
      });
      resolve();
    }).catch(function () {
      if (PICK.handle === handle) { list.textContent = 'Could not load shoe options. Please try again.'; pickMsg('Could not load shoe options.'); }
    });
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-ls2-pick-card]'); if (card) { e.preventDefault(); chooseCard(card); return; }
    var nav = e.target.closest && e.target.closest('[data-ls2-pick-nav]');
    if (nav) { var row = document.querySelector('[data-ls2-pick-row]'); if (row) row.scrollBy({ left: Number(nav.dataset.ls2PickNav) * row.clientWidth * 0.8, behavior: 'smooth' }); }
  });
  // Two-pair checkout: one atomic cart request; no auto-selected second shoe.
  // Single-pair orders continue through the theme's original product-form.js.
  document.addEventListener('submit', function (e) {
    var box = tierBox(); if (!box) return;
    var sid = box.dataset.section;
    var form = e.target;
    if (!form || form.id !== 'product-form-' + sid || (TIER[sid] || '1') !== '2') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var pick = document.querySelector('[data-ls2-pick]');
    if (!PICK.variant) {
      if (pick) pick.scrollIntoView({ behavior: 'smooth', block: 'center' });
      pickMsg('Please choose your second shoe and size first.');
      return;
    }
    if (secondPairBusy) return;
    var fd = new FormData(form);
    var mainId = Number(fd.get('id'));
    if (!mainId) {
      pickMsg('Please select the first shoe size and sole before adding both pairs.');
      return;
    }
    // Carry the main pair's selected line-item properties and selling plan.
    var first = { id: mainId, quantity: 1 };
    var props = {};
    fd.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && value !== '') props[m[1]] = value;
    });
    if (Object.keys(props).length) first.properties = props;
    if (fd.get('selling_plan')) first.selling_plan = Number(fd.get('selling_plan'));
    var second = { id: Number(PICK.variant), quantity: 1 };
    if (!second.id) return;
    secondPairBusy = true;
    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    pickMsg('Adding your two selected pairs...');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [first, second] })
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (err) {
        throw new Error(err.description || err.message || 'Unable to add both pairs.');
      });
      return r.json();
    }).then(function () {
      // Full cart navigation guarantees both lines and totals are refreshed
      // without requiring a second POST or theme-specific drawer hooks.
      window.location.assign(root + 'cart');
    }).catch(function (err) {
      secondPairBusy = false;
      if (submit) submit.disabled = false;
      pickMsg(err.message || 'Could not add both pairs. Please try again.');
    });
  }, true);
  function tierBox() { return document.querySelector('[data-ls2-tiers]'); }
  function qtyInput(sid, form) {
    var q = document.querySelector('#Quantity-' + sid) || (form && form.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"][form="product-form-' + sid + '"]');
    if (q) return q;
    if (!form) return null;
    q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; q.value = '1'; q.setAttribute('data-ls2-qty', '1');
    form.appendChild(q); return q;
  }
  function applyTier() {
    var box = tierBox(); if (!box) return;
    var sid = box.dataset.section;
    var tier = TIER[sid] || '1';
    var r = box.querySelector('.ls2-tier__radio[value="' + tier + '"]');
    if (r && !r.checked) r.checked = true;
    box.querySelectorAll('.ls2-tier').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('.ls2-tier__radio').value === tier); });
    box.querySelectorAll('[data-ls2-tier-foot]').forEach(function (f) { f.hidden = f.dataset.ls2TierFoot !== tier; });
    var form = document.getElementById('product-form-' + sid);
    var q = qtyInput(sid, form);
    if (q && (q.getAttribute('data-ls2-set') === '2' || (tier === '2' && q.value === '2'))) { q.value = '1'; q.removeAttribute('data-ls2-set'); }
    var pick = document.querySelector('[data-ls2-pick]');
    if (pick) { var showPick = tier === '2'; if (pick.hidden === showPick) pick.hidden = !showPick; }
    var btn = form && form.querySelector('[type="submit"]');
    if (btn && !btn.disabled) {
      var span = btn.querySelector('span') || btn;
      if (!btn.dataset.ls2Label) btn.dataset.ls2Label = span.textContent.trim();
      var want = btn.dataset.ls2Label + ' · ' + box.dataset.total1;
      if (tier === '2') want = PICK.variant ? 'Add both pairs · ' + fmt(Math.round(Number(box.dataset.base) * (100 - Number(box.dataset.pct2 || 30)) / 100) + Math.round(PICK.price * (100 - Number(box.dataset.pct2 || 30)) / 100)) : 'Choose your second pair';
      if (span.textContent !== want) span.textContent = want;
    }
    var sticky = document.querySelector('[data-ls-sticky-btn]');
    if (sticky && tier === '2' && sticky.textContent === 'Add to cart') sticky.textContent = PICK.variant ? 'Add both pairs' : 'Choose second pair';
  }
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('.ls2-tier__radio'); if (!r) return;
    var box = r.closest('[data-ls2-tiers]'); TIER[box.dataset.section] = r.value; if (r.value !== '2') { PICK.variant = null; PICK.handle = null; PICK.price = 0; } applyTier();
  });

  function init() {
    apply(saved());
    var box = tierBox();
    if (box) { var selected = box.querySelector('.ls2-tier__radio:checked'); TIER[box.dataset.section] = selected ? selected.value : '1'; }
    setupSticky(); applyTier();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { apply(saved()); applyTier(); });
})();
